export const sidenavPath = [
  '/dashboard/home',
  '/dashboard/courses/course-list',
  '/dashboard/courses/course-request',
  '/dashboard/courses/free-trial',
  '/dashboard/assessment',
  '/dashboard/mock-test/list',
  '/dashboard/mock-test/assign-test',
  '/dashboard/information/company',
  '/dashboard/information/testimonials',
  '/dashboard/information/blogs',
  '/dashboard/information/landing',
  '/dashboard/information/advertisement',
  '/dashboard/information/terms-and-conditions',
  '/dashboard/information/faq',
  '/dashboard/users/client',
  '/dashboard/users/partner',
  '/dashboard/users/instructor',
  '/dashboard/users/staff',
  '/dashboard/doubts/requests',
  // '/dashboard/doubts/reports',
  '/dashboard/doubts/comments-reports',
  '/dashboard/lead',
  '/dashboard/profile',
  '/notifications',
  '/dashboard/settings',
  '/dashboard/rooms/room',
  '/dashboard/rooms/report-issues',
  '/dashboard/finance/coupon',
  '/dashboard/finance/ledger',
  '/dashboard/users/pending-instructor',
  '/dashboard/refer',
  '/dashboard/notes',
  '/dashboard/partners',
  '/dashboard/physical-class',
  '/dashboard/partner-clients',
  '/dashboard/clients-payment',
  '/dashboard/task',
];
